/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { EquipmentType } from '../model'
// @ts-ignore
import type { YardBlockAreaPartialDto } from '../model'
// @ts-ignore
import type { YardBlockDto } from '../model'
/**
 * YardBlocksApi - axios parameter creator
 */
export const YardBlocksApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} [filter]
     * @param {Array<EquipmentType>} [equipmentTypes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYardBlockAreaByPartialName: async (
      filter?: string,
      equipmentTypes?: Array<EquipmentType>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/YardBlocks/getYardBlockAreaByPartialName`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (filter !== undefined) {
        localVarQueryParameter['Filter'] = filter
      }

      if (equipmentTypes) {
        localVarQueryParameter['EquipmentTypes'] = equipmentTypes
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {boolean} [withNoWorkAreaAssigned]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYardBlockByWorkInstruction: async (
      withNoWorkAreaAssigned?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/YardBlocks`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (withNoWorkAreaAssigned !== undefined) {
        localVarQueryParameter['WithNoWorkAreaAssigned'] = withNoWorkAreaAssigned
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncYardBlockSlots: async (
      body?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/YardBlocks/syncYardBlockSlots`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * YardBlocksApi - functional programming interface
 */
export const YardBlocksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = YardBlocksApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {string} [filter]
     * @param {Array<EquipmentType>} [equipmentTypes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getYardBlockAreaByPartialName(
      filter?: string,
      equipmentTypes?: Array<EquipmentType>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockAreaPartialDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getYardBlockAreaByPartialName(
        filter,
        equipmentTypes,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.getYardBlockAreaByPartialName']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {boolean} [withNoWorkAreaAssigned]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getYardBlockByWorkInstruction(
      withNoWorkAreaAssigned?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<YardBlockDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getYardBlockByWorkInstruction(
        withNoWorkAreaAssigned,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.getYardBlockByWorkInstruction']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async syncYardBlockSlots(
      body?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.syncYardBlockSlots(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['YardBlocksApi.syncYardBlockSlots']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * YardBlocksApi - factory interface
 */
export const YardBlocksApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = YardBlocksApiFp(configuration)
  return {
    /**
     *
     * @param {string} [filter]
     * @param {Array<EquipmentType>} [equipmentTypes]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYardBlockAreaByPartialName(
      filter?: string,
      equipmentTypes?: Array<EquipmentType>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<YardBlockAreaPartialDto>> {
      return localVarFp
        .getYardBlockAreaByPartialName(filter, equipmentTypes, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {boolean} [withNoWorkAreaAssigned]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getYardBlockByWorkInstruction(
      withNoWorkAreaAssigned?: boolean,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<YardBlockDto>> {
      return localVarFp
        .getYardBlockByWorkInstruction(withNoWorkAreaAssigned, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {string} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncYardBlockSlots(body?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.syncYardBlockSlots(body, options).then(request => request(axios, basePath))
    },
  }
}

/**
 * YardBlocksApi - object-oriented interface
 */
export class YardBlocksApi extends BaseAPI {
  /**
   *
   * @param {string} [filter]
   * @param {Array<EquipmentType>} [equipmentTypes]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getYardBlockAreaByPartialName(
    filter?: string,
    equipmentTypes?: Array<EquipmentType>,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .getYardBlockAreaByPartialName(filter, equipmentTypes, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {boolean} [withNoWorkAreaAssigned]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getYardBlockByWorkInstruction(
    withNoWorkAreaAssigned?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return YardBlocksApiFp(this.configuration)
      .getYardBlockByWorkInstruction(withNoWorkAreaAssigned, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public syncYardBlockSlots(body?: string, options?: RawAxiosRequestConfig) {
    return YardBlocksApiFp(this.configuration)
      .syncYardBlockSlots(body, options)
      .then(request => request(this.axios, this.basePath))
  }
}
